import { useBaseDrop } from '../common/useBaseDrop'
import { DND_TYPE } from '../constant'

export const useNoteDropZone = () => {
  return useBaseDrop({ accept: DND_TYPE.NOTE })
}
